export const UPDATE_INTERVAL = process.env.VUE_APP_UPDATE_INTERVAL || 10e3
export const POINT_UPDATE_INTERVAL = process.env.VUE_APP_WATCH_INTERVAL || 20e3
export const WATCH_UPDATE_INTERVAL = process.env.VUE_APP_WATCH_INTERVAL || 20e3
